import script from "./MeaProductView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeaProductView.vue?vue&type=script&setup=true&lang=ts"

import "./MeaProductView.vue?vue&type=style&index=0&id=fad2382a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad2382a"]])

export default __exports__